// Vendors
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import ReactDatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import MaskedInput from "react-maskedinput";
import { isMobile } from "react-device-detect";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import "./GetStartedBirthVerification.scss";

// Actions
import useGlobal from "../../../../store";

// Components
import Progress from "../../Progress";
import { TxAlert, TxRadioGroup } from 'texkit-ui';
import StepNavigationButtons from '../../StepNavigationButtons/StepNavigationButtons';

function GetStartedBirthVerification(props) {
  const { t } = useTranslation();
  const [globalState, globalActions] = useGlobal();
  const [showAlert, setShowAlert] = useState(false);
  const [deliveryType, setDeliveryType] = useState(null);

  const SignupSchema = yup.object().shape({
    dateOfBirth: yup
      .date()
      .required(t("DATE_COMMON_ERRORS.VERIFY_DATE_RANGE"))
      .min(new Date("1903-01-01"), t("DATE_COMMON_ERRORS.VERIFY_DATE_MIN"))
      .max(new Date(), t("DATE_COMMON_ERRORS.VERIFY_DATE_RANGE_MAX"))
      .typeError(t("DATE_COMMON_ERRORS.VERIFY_DATE_RANGE")),

    validateState: yup.boolean(
      globalState.verifyIdentityData.idVerified === "Y" ? true : false
    ),

    selectedState: yup.object().when("validateState", {
      is: (validateState) => validateState === false,
      then: yup.object().shape({
        label: yup
          .string()
          .required(t("GET_STARTED_BIRTHCERTIFICATE.STATE_ERROR")),

        value: yup
          .string()
          .required(t("GET_STARTED_BIRTHCERTIFICATE.STATE_ERROR")),
      }),
    }),
  });

  const { handleSubmit, control, errors } = useForm({
    reValidateMode: "onChange",
    resolver: yupResolver(SignupSchema),
  });

  const stateList = props.stateList;

  const onSubmit = (data) => {
    if (deliveryType === "Online") {
      globalActions.setIsOnlineOrder(true);
    } else {
      globalActions.setIsOnlineOrder(false);
    }
    globalActions.getStartedBirthVerificationInfo(data);
    if (
      globalState.verifyIdentityData.idVerified !== undefined &&
      globalState.verifyIdentityData.idVerified === "Y"
    ) {
      props.nextCallback(3);
    } else {
      data.selectedState.value === "TX"
        ? props.nextCallback()
        : props.nextCallback(2);
    }
  };

  const isValidOnlineOrder = () => {
    if (!globalState.totalOrderRecords || globalState.totalOrderRecords.length === 0) {
      return true;
    } else if ((globalState.totalOrderRecords.length === 1) &&
       (globalState.saveEditIndex.referenceType === globalState.totalOrderRecords[0].certificateInfoType)) {
      return true;
    }
    return false;
  }

  const setDeliveryRadio = () => {
    if ((globalState.totalOrderRecords.length === 1) && 
      (globalState.saveEditIndex.referenceType === globalState.totalOrderRecords[0].certificateInfoType)) {
         if (globalState.isOnlineOrder) { setDeliveryType("Online"); return "Online"; }
         else { setDeliveryType("Mail"); return "Mail"; }
    } else if (globalState.isOnlineOrder !== undefined) {
      if (globalState.isOnlineOrder) { setDeliveryType("Online"); return "Online"; }
      else { setDeliveryType("Mail"); return "Mail"; }
    } else {
      return undefined;
    }
  }

  return (
    <div>
      <Progress currentStep={1} totalSteps={4} />
      <h1 className="birthverification-heading">
        {t("BIRTH_VERIFICATION.HEADING")}
      </h1>
      <p className="birthverification-content">
        {t("BIRTH_VERIFICATION.DESCRIPTION")}
      </p>
      <div>
        <label className="birthverification-info">
          {t("BIRTH_VERIFICATION.GET_STARTED")}
        </label>
        <label className="birthverification-info1">
          {t("BIRTH_VERIFICATION.GET_STARTED_INFO")}
        </label>
        <form
          className="birth-content-section"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="birthverification-div">
            <div className="birthVerfiyDateRange">
              <div className="option-container">
                {(globalState.verifyIdentityData.idVerified === undefined ||
                  globalState.verifyIdentityData.idVerified === "" ||
                  globalState.verifyIdentityData.idVerified === "N") && (
                  <>
                    <label className="birth-content ">
                      {t("COMMONS.CHOOSE_STATE")}

                      <div className="select-align">
                        <Controller
                          name="selectedState"
                          className={`field-label-padding ${
                            errors.selectedState ? "error-red" : ""
                          }`}
                          as={Select}
                          options={stateList}
                          control={control}
                          isClearable
                          defaultValue={
                            globalState.getStartedBirthVerificationInfo
                              .selectedState.label
                              ? globalState.getStartedBirthVerificationInfo
                                  .selectedState
                              : ""
                          }
                          rules={{ required: true }}
                        />
                        {errors.selectedState && (
                          <p className="error-red-content">
                            {t("GET_STARTED_BIRTHCERTIFICATE.STATE_ERROR")}
                          </p>
                        )}
                      </div>
                    </label>
                  </>
                )}

                <label
                  htmlFor="dateOfBirth"
                  className="birthverification-info1"
                >
                  {t("BIRTH_VERIFICATION.GET_STARTED_TYPE")}
                </label>

                <div className="birth-date">
                  <Controller
                    control={control}
                    name="dateOfBirth"
                    rules={{ required: true }}
                    className="input-date"
                    defaultValue={
                      globalState.getStartedBirthVerificationInfo.dateOfBirth
                        ? globalState.getStartedBirthVerificationInfo
                            .dateOfBirth
                        : ""
                    }
                    render={({ onChange, onBlur, value }) => (
                      <ReactDatePicker
                        onChange={onChange}
                        onBlur={onBlur}
                        selected={value}
                        id="dateOfBirth"
                        className={`input-date get-state-birth ${
                          errors.dateOfBirth ? "error-red" : ""
                        }`}
                        showMonthDropdown
                        showYearDropdown
                        open={isMobile ? false : undefined}
                        customInput={<MaskedInput mask="11/11/1111" />}
                        placeholderText="00/00/0000"
                      />
                    )}
                  />
                  {errors.dateOfBirth && (
                    <p className="error-red-content">
                      {errors.dateOfBirth.message}
                    </p>
                  )}
                </div>
              </div>

            </div>
            <div className="birthVerifyDeliveryOptions">
              <label className="birthverification-delivery-type">
                {t("ONLINE_ORDER.HEADING_DELIVERY_TYPE")}
              </label>

              <TxRadioGroup
                name="delivery"
                options={[
                  {
                    label: t("ONLINE_ORDER.ONLINE"),
                    value: "Online",
                  },
                  {
                    label: t("ONLINE_ORDER.MAIL"),
                    value: "Mail",
                  },
                ]}
                value={setDeliveryRadio}
                onChange={(e) => {
                  if (e.target.value === "Online") {
                    if (!isValidOnlineOrder()) {
                      setShowAlert(true);
                    } else {
                      setDeliveryType(e.target.value);
                      globalActions.setIsOnlineOrder(true);
                    }
                  }
                  if (e.target.value === "Mail") {
                    setShowAlert(false);
                    setDeliveryType(e.target.value);
                    globalActions.setIsOnlineOrder(false);
                  }
                  return;
                }}
              />

             {showAlert && (
                <TxAlert
                  heading={t("ONLINE_ORDER.ALERT_HEADING")}
                  children={<div>
                    <ul>
                      <Trans 
                        i18nKey="ONLINE_ORDER.ALERT_BODY_1"
                        components={[
                          <p />,
                          <li />
                        ]}
                      />
                      <li>
                        <Link to={t("URLS.ORDER_REVIEW")}>
                          <Trans i18nKey="ONLINE_ORDER.RETURN_TO_ORDER_REVIEW"/>
                        </Link>
                        <Trans i18nKey="ONLINE_ORDER.ALERT_BODY_2"/>
                      </li>
                   </ul>
                  </div>}
                  className="online-alert"
                />
              )}
            </div>
          <StepNavigationButtons />
          </div>
        </form>
      </div>
    </div>
  );
}

export default GetStartedBirthVerification;
